import React from 'react';
import { Button, CircularProgress } from '@mui/material';

const LoadingButton = ({
  loading = false,
  children,
  disabled,
  loadingText,
  startIcon,
  ...props
}) => {
  return (
    <Button
      {...props}
      disabled={loading || disabled}
      startIcon={loading ? <CircularProgress size={16} /> : startIcon}
    >
      {loading && loadingText ? loadingText : children}
    </Button>
  );
};

export default LoadingButton;
